import React from "react";
import { motion,AnimatePresence } from "framer-motion";
import DetailAtk from "./DetailAtk";
function DataAtk({atks,getLatestMasuk,getLatestKeluar,getTotalMasuk,getTotalKeluar,loading,calculateStokAkhir,getStokStatus,masuk,keluar}) {
  return (
    <table className="w-full min-w-[600px]">
      <thead className="bg-gray-50">
        <tr>
          <th className="px-6 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
            Kode
          </th>
          <th className="px-6 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
            Nama Barang
          </th>
          <th className="px-6 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
            Spesifikasi
          </th>
          <th className="px-6 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
            Satuan
          </th>
          <th className="px-6 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
            Stok Awal
          </th>
          <th className="px-6 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
            Masuk
          </th>
          <th className="px-6 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
            Keluar
          </th>
          <th className="px-6 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
            Stok Akhir
          </th>
          <th className="px-6 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
            Aksi
          </th>
        </tr>
      </thead>
      <tbody className="bg-white divide-y divide-gray-200">
        {loading ? (
          <tr>
            <td colSpan="9" className="px-6 py-12 text-center">
              <div className="flex flex-col items-center justify-center">
                <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary mb-4"></div>
                <div className="text-gray-500">Memuat data ATK...</div>
              </div>
            </td>
          </tr>
        ) : (
          <AnimatePresence>
            {atks.map((item, index) => {
              const latestMasuk = getLatestMasuk(item.id);
              const latestKeluar = getLatestKeluar(item.id);
              const totalMasuk = getTotalMasuk(item.id);
              const totalKeluar = getTotalKeluar(item.id);
              const stokAkhir = calculateStokAkhir(
                item.stok_awal || 0,
                totalMasuk,
                totalKeluar
              );
              const stokStatusClass = getStokStatus(stokAkhir);

              return (
                <motion.tr
                  key={item.id}
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  exit={{ opacity: 0, y: -20 }}
                  transition={{ duration: 0.3, delay: index * 0.05 }}
                  className="hover:bg-gray-50 transition-colors duration-200"
                >
                  <td className="px-6 py-4 whitespace-nowrap">
                    <div className="text-sm font-medium text-gray-900">
                      {item.kode}
                    </div>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap">
                    <div className="text-sm font-medium text-gray-900">
                      {item.nabar}
                    </div>
                    <div className="text-xs text-gray-500 capitalize">
                      {item.kategori?.replace("-", " ")}
                    </div>
                  </td>
                  <td className="px-6 py-4">
                    <div className="text-sm text-gray-900 max-w-xs truncate">
                      {item.spec}
                    </div>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap">
                    <div className="text-sm text-gray-900">{item.satuan}</div>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap">
                    <div className="text-sm text-gray-900 font-medium">
                      {(item.stok_awal || 0).toLocaleString()}
                    </div>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap">
                    <div className="text-sm text-green-600 font-medium">
                      {latestMasuk > 0
                        ? `+${latestMasuk.toLocaleString()}`
                        : "-"}
                    </div>
                    <div className="text-xs text-gray-500">
                      Total: {totalMasuk.toLocaleString()}
                    </div>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap">
                    <div className="text-sm text-red-600 font-medium">
                      {latestKeluar > 0
                        ? `-${latestKeluar.toLocaleString()}`
                        : "-"}
                    </div>
                    <div className="text-xs text-gray-500">
                      Total: {totalKeluar.toLocaleString()}
                    </div>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap">
                    <span
                      className={`inline-flex px-3 py-1 rounded-full text-sm font-medium ${stokStatusClass}`}
                    >
                      {stokAkhir.toLocaleString()}
                    </span>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm font-medium">
                    <div className="flex items-center gap-2">
                      <DetailAtk 
                        id={item.id} 
                        item={item}
                        masuks={masuk} 
                        keluars={keluar} 
                      />
                    </div>
                  </td>
                </motion.tr>
              );
            })}
          </AnimatePresence>
        )}
      </tbody>
    </table>
  );
}

export default DataAtk;
